import React, { useState } from 'react';
import { motion } from 'framer-motion';
import BeltPicker from '../BeltPicker';
import { BELT_IDS, beltLabel } from '../../data/belts';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlay, FiShuffle, FiList, FiTarget } = FiIcons;


export default function TrainingSetup({ onStart, userBelt }) {
  const suggestedBelt = BELT_IDS.includes(userBelt) ? userBelt : 'blanca';
  const [selectedBelt, setSelectedBelt] = useState(suggestedBelt);
  const [type, setType] = useState('all');
  const [isRandom, setIsRandom] = useState(false);

  return (
    <div className="max-w-4xl mx-auto px-4 md:px-6 py-12">
      <div className="text-center mb-12">
        <span className="text-red-300 font-black tracking-[0.4em] uppercase text-xs mb-4 block [text-shadow:_0_1px_6px_rgba(0,0,0,0.85)]">Módulo de Práctica</span>
        <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter text-white [text-shadow:_0_2px_10px_rgba(0,0,0,0.5)]">Configura tu Sesión</h2>
      </div>

      <div className="glass-card rounded-[2rem] md:rounded-[2.5rem] p-5 md:p-12 space-y-10 md:space-y-12">
        <section>
          {/* Texto cambiado a Blanco Puro */}
          <label className="text-sm font-black text-white uppercase tracking-[0.25em] mb-6 block [text-shadow:_0_1px_6px_rgba(0,0,0,0.85)]">1. Selecciona tu Grado</label>
          <p className="text-white text-base mb-6 -mt-3 font-medium [text-shadow:_0_1px_6px_rgba(0,0,0,0.85)]">
            Te sugerimos practicar hasta tu grado actual: <span className="font-black text-white">{beltLabel(suggestedBelt)}</span>.
            Puedes cambiarlo en tu perfil.
          </p>
          <BeltPicker value={selectedBelt} onChange={setSelectedBelt} markedBelt={suggestedBelt} />
        </section>

        <div className="grid md:grid-cols-2 gap-12">
          <section>
            {/* Texto cambiado a Blanco Puro */}
            <label className="text-sm font-black text-white uppercase tracking-[0.25em] mb-6 block [text-shadow:_0_1px_6px_rgba(0,0,0,0.85)]">2. Tipo de Técnica</label>
            <div className="flex gap-2 md:gap-3">
              {[
                { id: 'all', label: 'Todo', icon: FiTarget },
                { id: 'secuencias', label: 'Secuencias', icon: FiList },
                { id: 'formas', label: 'Formas', icon: FiPlay }
              ].map((opt) => (
                <button
                  key={opt.id}
                  onClick={() => setType(opt.id)}
                  className={`flex-1 min-w-0 flex flex-col items-center gap-2 md:gap-3 px-1 py-3 md:p-5 rounded-2xl md:rounded-3xl border transition-all ${
                    type === opt.id
                      ? 'bg-black/45 border-white text-white ring-1 ring-white/60 shadow-lg'
                      : 'bg-black/25 border-white/25 text-white/85 hover:bg-black/35 hover:text-white'
                  }`}
                >
                  <SafeIcon icon={opt.icon} className="w-5 h-5" />
                  <span className="text-[10px] md:text-xs font-black uppercase tracking-wide md:tracking-widest [text-shadow:_0_1px_6px_rgba(0,0,0,0.85)]">{opt.label}</span>
                </button>
              ))}
            </div>
          </section>

          <section>
            {/* Texto cambiado a Blanco Puro */}
            <label className="text-sm font-black text-white uppercase tracking-[0.25em] mb-6 block [text-shadow:_0_1px_6px_rgba(0,0,0,0.85)]">3. Orden de Práctica</label>
            <div className="flex gap-2 md:gap-3">
              <button
                onClick={() => setIsRandom(false)}
                className={`flex-1 min-w-0 flex flex-col items-center gap-2 md:gap-3 px-1 py-3 md:p-5 rounded-2xl md:rounded-3xl border transition-all ${
                  !isRandom
                    ? 'bg-black/45 border-white text-white ring-1 ring-white/60 shadow-lg'
                    : 'bg-black/25 border-white/25 text-white/85 hover:bg-black/35 hover:text-white'
                }`}
              >
                <SafeIcon icon={FiList} className="w-5 h-5" />
                <span className="text-[10px] md:text-xs font-black uppercase tracking-wide md:tracking-widest [text-shadow:_0_1px_6px_rgba(0,0,0,0.85)]">Ordenado</span>
              </button>
              <button
                onClick={() => setIsRandom(true)}
                className={`flex-1 min-w-0 flex flex-col items-center gap-2 md:gap-3 px-1 py-3 md:p-5 rounded-2xl md:rounded-3xl border transition-all ${
                  isRandom
                    ? 'bg-black/45 border-white text-white ring-1 ring-white/60 shadow-lg'
                    : 'bg-black/25 border-white/25 text-white/85 hover:bg-black/35 hover:text-white'
                }`}
              >
                <SafeIcon icon={FiShuffle} className="w-5 h-5" />
                <span className="text-[10px] md:text-xs font-black uppercase tracking-wide md:tracking-widest [text-shadow:_0_1px_6px_rgba(0,0,0,0.85)]">Aleatorio</span>
              </button>
            </div>
          </section>
        </div>

        <button
          onClick={() => onStart({ selectedBelt, type, isRandom })}
          className="w-full bg-red-700 hover:bg-red-600 text-white py-5 md:py-6 rounded-3xl font-black uppercase tracking-[0.2em] md:tracking-[0.35em] text-xs md:text-sm transition-all shadow-xl shadow-red-600/20 active:scale-95 flex items-center justify-center gap-3"
        >
          Iniciar Entrenamiento <SafeIcon icon={FiPlay} />
        </button>
      </div>
    </div>
  );
}